import create from 'zustand'
import performance from '../performance'
import logger from '../logger'
import { readRemoteFile } from 'react-papaparse'
import {
  SHOW_NATIVE_AMERICAN,
  SHOW_PUERTO_RICO
} from '../explorer/app/selectors'

const ENDPOINT = process.env.REACT_APP_DATA_ENDPOINT
const DATA_ENDPOINT = ENDPOINT + 'explorer'
const DATA_VERSION = 6

const AUTO_PARSE_COLS = {
  id: false,
  lon: true,
  lat: true,
  state: true,
  u: true,
  s: true,
  t: true,
  r: true,
  name: false,
  all_ses: true,
  w_ses: true,
  b_ses: true,
  h_ses: true,
  i_ses: true,
  a_ses: true,
  wa_se: true,
  wb_se: true,
  wh_se: true,
  wi_se: true,
  // all_frl: true,
  // w_frl: true,
  // b_frl: true,
  // h_frl: true,
  // i_frl: true,
  // a_frl: true,
  wa_seg: true,
  wb_seg: true,
  wh_seg: true,
  wi_seg: true,
  pn_seg: true,
  wa_min: true,
  wb_min: true,
  wh_min: true,
  wi_min: true,
  all_sz: true,
  all_grd: true,
  all_grd_e: true,
  all_coh: true,
  all_coh_e: true,
  all_imp: true,
  all_imp_e: true,
  all_avg: true,
  all_avg_e: true,
  all_avg2009: true,
  all_avg2010: true,
  all_avg2011: true,
  all_avg2012: true,
  all_avg2013: true,
  all_avg2014: true,
  all_avg2015: true,
  all_avg2016: true,
  all_avg2017: true,
  all_avg2018: true,
  all_avg2019: true,
  all_avg2022: true,
  all_avg2023: true,
  all_avg2024: true,
  all_avg2025: true,
  a_sz: true,
  a_grd: true,
  a_grd_e: true,
  a_coh: true,
  a_coh_e: true,
  a_imp: true,
  a_imp_e: true,
  a_avg: true,
  a_avg_e: true,
  a_avg2009: true,
  a_avg2010: true,
  a_avg2011: true,
  a_avg2012: true,
  a_avg2013: true,
  a_avg2014: true,
  a_avg2015: true,
  a_avg2016: true,
  a_avg2017: true,
  a_avg2018: true,
  a_avg2019: true,
  a_avg2022: true,
  a_avg2023: true,
  a_avg2024: true,
  a_avg2025: true,
  b_sz: true,
  b_grd: true,
  b_grd_e: true,
  b_coh: true,
  b_coh_e: true,
  b_imp: true,
  b_imp_e: true,
  b_avg: true,
  b_avg_e: true,
  b_avg2009: true,
  b_avg2010: true,
  b_avg2011: true,
  b_avg2012: true,
  b_avg2013: true,
  b_avg2014: true,
  b_avg2015: true,
  b_avg2016: true,
  b_avg2017: true,
  b_avg2018: true,
  b_avg2019: true,
  b_avg2022: true,
  b_avg2023: true,
  b_avg2024: true,
  b_avg2025: true,
  p_sz: true,
  p_grd: true,
  p_grd_e: true,
  p_coh: true,
  p_coh_e: true,
  p_imp: true,
  p_imp_e: true,
  p_avg: true,
  p_avg_e: true,
  p_avg2009: true,
  p_avg2010: true,
  p_avg2011: true,
  p_avg2012: true,
  p_avg2013: true,
  p_avg2014: true,
  p_avg2015: true,
  p_avg2016: true,
  p_avg2017: true,
  p_avg2018: true,
  p_avg2019: true,
  p_avg2022: true,
  p_avg2023: true,
  p_avg2024: true,
  p_avg2025: true,
  f_sz: true,
  f_grd: true,
  f_grd_e: true,
  f_coh: true,
  f_coh_e: true,
  f_imp: true,
  f_imp_e: true,
  f_avg: true,
  f_avg_e: true,
  f_avg2009: true,
  f_avg2010: true,
  f_avg2011: true,
  f_avg2012: true,
  f_avg2013: true,
  f_avg2014: true,
  f_avg2015: true,
  f_avg2016: true,
  f_avg2017: true,
  f_avg2018: true,
  f_avg2019: true,
  f_avg2022: true,
  f_avg2023: true,
  f_avg2024: true,
  f_avg2025: true,
  h_sz: true,
  h_grd: true,
  h_grd_e: true,
  h_coh: true,
  h_coh_e: true,
  h_imp: true,
  h_imp_e: true,
  h_avg: true,
  h_avg_e: true,
  h_avg2009: true,
  h_avg2010: true,
  h_avg2011: true,
  h_avg2012: true,
  h_avg2013: true,
  h_avg2014: true,
  h_avg2015: true,
  h_avg2016: true,
  h_avg2017: true,
  h_avg2018: true,
  h_avg2019: true,
  h_avg2022: true,
  h_avg2023: true,
  h_avg2024: true,
  h_avg2025: true,
  m_sz: true,
  m_grd: true,
  m_grd_e: true,
  m_coh: true,
  m_coh_e: true,
  m_imp: true,
  m_imp_e: true,
  m_avg: true,
  m_avg_e: true,
  m_avg2009: true,
  m_avg2010: true,
  m_avg2011: true,
  m_avg2012: true,
  m_avg2013: true,
  m_avg2014: true,
  m_avg2015: true,
  m_avg2016: true,
  m_avg2017: true,
  m_avg2018: true,
  m_avg2019: true,
  m_avg2022: true,
  m_avg2023: true,
  m_avg2024: true,
  m_avg2025: true,
  i_sz: true,
  i_grd: true,
  i_grd_e: true,
  i_coh: true,
  i_coh_e: true,
  i_imp: true,
  i_imp_e: true,
  i_avg: true,
  i_avg_e: true,
  i_avg2009: true,
  i_avg2010: true,
  i_avg2011: true,
  i_avg2012: true,
  i_avg2013: true,
  i_avg2014: true,
  i_avg2015: true,
  i_avg2016: true,
  i_avg2017: true,
  i_avg2018: true,
  i_avg2019: true,
  i_avg2022: true,
  i_avg2023: true,
  i_avg2024: true,
  i_avg2025: true,
  np_sz: true,
  np_grd: true,
  np_grd_e: true,
  np_coh: true,
  np_coh_e: true,
  np_imp: true,
  np_imp_e: true,
  np_avg: true,
  np_avg_e: true,
  np_avg2009: true,
  np_avg2010: true,
  np_avg2011: true,
  np_avg2012: true,
  np_avg2013: true,
  np_avg2014: true,
  np_avg2015: true,
  np_avg2016: true,
  np_avg2017: true,
  np_avg2018: true,
  np_avg2019: true,
  np_avg2022: true,
  np_avg2023: true,
  np_avg2024: true,
  np_avg2025: true,
  w_sz: true,
  w_grd: true,
  w_grd_e: true,
  w_coh: true,
  w_coh_e: true,
  w_imp: true,
  w_imp_e: true,
  w_avg: true,
  w_avg_e: true,
  w_avg2009: true,
  w_avg2010: true,
  w_avg2011: true,
  w_avg2012: true,
  w_avg2013: true,
  w_avg2014: true,
  w_avg2015: true,
  w_avg2016: true,
  w_avg2017: true,
  w_avg2018: true,
  w_avg2019: true,
  w_avg2022: true,
  w_avg2023: true,
  w_avg2024: true,
  w_avg2025: true,
  //  Gaps
  wa_sz: true,
	wa_grd: true,
	wa_grd_e: true,
	wa_coh: true,
	wa_coh_e: true,
	wa_imp: true,
	wa_imp_e: true,
	wa_avg: true,
	wa_avg_e: true,
	wa_avg2009: true,
	wa_avg2010: true,
	wa_avg2011: true,
	wa_avg2012: true,
	wa_avg2013: true,
	wa_avg2014: true,
	wa_avg2015: true,
	wa_avg2016: true,
	wa_avg2017: true,
	wa_avg2018: true,
	wa_avg2019: true,
	wa_avg2022: true,
	wa_avg2023: true,
	wa_avg2024: true,
	wa_avg2025: true,
	wb_sz: true,
	wb_grd: true,
	wb_grd_e: true,
	wb_coh: true,
	wb_coh_e: true,
	wb_imp: true,
	wb_imp_e: true,
	wb_avg: true,
	wb_avg_e: true,
	wb_avg2009: true,
	wb_avg2010: true,
	wb_avg2011: true,
	wb_avg2012: true,
	wb_avg2013: true,
	wb_avg2014: true,
	wb_avg2015: true,
	wb_avg2016: true,
	wb_avg2017: true,
	wb_avg2018: true,
	wb_avg2019: true,
	wb_avg2022: true,
	wb_avg2023: true,
	wb_avg2024: true,
	wb_avg2025: true,
	wh_sz: true,
	wh_grd: true,
	wh_grd_e: true,
	wh_coh: true,
	wh_coh_e: true,
	wh_imp: true,
	wh_imp_e: true,
	wh_avg: true,
	wh_avg_e: true,
	wh_avg2009: true,
	wh_avg2010: true,
	wh_avg2011: true,
	wh_avg2012: true,
	wh_avg2013: true,
	wh_avg2014: true,
	wh_avg2015: true,
	wh_avg2016: true,
	wh_avg2017: true,
	wh_avg2018: true,
	wh_avg2019: true,
	wh_avg2022: true,
	wh_avg2023: true,
	wh_avg2024: true,
	wh_avg2025: true,
	wi_sz: true,
	wi_grd: true,
	wi_grd_e: true,
	wi_coh: true,
	wi_coh_e: true,
	wi_imp: true,
	wi_imp_e: true,
	wi_avg: true,
	wi_avg_e: true,
	wi_avg2009: true,
	wi_avg2010: true,
	wi_avg2011: true,
	wi_avg2012: true,
	wi_avg2013: true,
	wi_avg2014: true,
	wi_avg2015: true,
	wi_avg2016: true,
	wi_avg2017: true,
	wi_avg2018: true,
	wi_avg2019: true,
	wi_avg2022: true,
	wi_avg2023: true,
	wi_avg2024: true,
	wi_avg2025: true,
	mf_sz: true,
	mf_grd: true,
	mf_grd_e: true,
	mf_coh: true,
	mf_coh_e: true,
	mf_imp: true,
	mf_imp_e: true,
	mf_avg: true,
	mf_avg_e: true,
	mf_avg2009: true,
	mf_avg2010: true,
	mf_avg2011: true,
	mf_avg2012: true,
	mf_avg2013: true,
	mf_avg2014: true,
	mf_avg2015: true,
	mf_avg2016: true,
	mf_avg2017: true,
	mf_avg2018: true,
	mf_avg2019: true,
	mf_avg2022: true,
	mf_avg2023: true,
	mf_avg2024: true,
	mf_avg2025: true,
	pn_sz: true,
	pn_grd: true,
	pn_grd_e: true,
	pn_coh: true,
	pn_coh_e: true,
	pn_imp: true,
	pn_imp_e: true,
	pn_avg: true,
	pn_avg_e: true,
	pn_avg2009: true,
	pn_avg2010: true,
	pn_avg2011: true,
	pn_avg2012: true,
	pn_avg2013: true,
	pn_avg2014: true,
	pn_avg2015: true,
	pn_avg2016: true,
	pn_avg2017: true,
	pn_avg2018: true,
	pn_avg2019: true,
	pn_avg2022: true,
	pn_avg2023: true,
	pn_avg2024: true,
	pn_avg2025: true,
  // 
  e: true,
  m: true,
  c: true,
  ch: true,
  mg: true,
  bie: true,
  fid: true
}

const shapeData = (data, dataSetId) => {
  let filteredData = data
  // TEMPORARY: filter out BIE schools on non-embargoed link
  if (!SHOW_NATIVE_AMERICAN) {
    filteredData = filteredData.filter(d => !d.bie)
  }
  // TEMPORARY: filter out Puerto Rico data on non-embargoed link
  if (!SHOW_PUERTO_RICO) {
    filteredData = filteredData.filter(
      d => d.id.substr(0, 2) !== '72'
    )
  }
  // add a flag for "regular" schools: non-magnet, non-charter, non-bie
  if (dataSetId === 'schools') {
    filteredData = filteredData.map(d => ({
      ...d,
      rg: !!d.bie || !!d.ch || !!d.mg ? null : 1
    }))
  }
  // sort data by number of students (`all_sz`)
  filteredData.sort((a, b) => b['all_sz'] - a['all_sz'])
  // HACK: rename `np_seg` to `pn_seg`, as it is a gap variable (not non-poor)
  // this can be removed when this issue is closed: https://github.com/Hyperobjekt/seda-etl/issues/35
  // mutates original to reduce performance impact
  // HACK_FIX_NP_SEG(filteredData)
  return filteredData
}

/**
 *
 * @param {*} region
 */
const loadDataSet = (dataSetId, insertData, options = {}) => {
  const url = DATA_ENDPOINT + '/' + dataSetId + '.csv' + '?version=' + DATA_VERSION
	console.log(url)
  logger.debug('fetching dataset:', url)
  // const result = []
  return new Promise((resolve, reject) => {
    readRemoteFile(url, {
      header: true,
      worker: true,
      dynamicTyping: AUTO_PARSE_COLS,
      // for streaming data:
      // step: row => {
      //   // insertData(dataSetId, [row.data])
      //   // const id = row.data.id
      //   result.push(row.data)
      // },
      complete: results => {
		console.log(results?.data)
        resolve(results?.data)
      },
      error: error => {
        console.error(error)
        reject(error)
      },
      ...options
    })
  })
}

/**
 * Renames `np_seg` data attribute to `pn_seg` due to pipeline error
 * @param {*} data
 */
const HACK_FIX_NP_SEG = data => {
  if (
    data &&
    data[0] &&
    Object.keys(data[0]).indexOf('np_seg') > -1
  ) {
    for (let i = 0; i < data.length; i++) {
      data[i]['pn_seg'] = data[i]['np_seg']
      delete data[i]['np_seg']
    }
  }
}

const useStaticData = create((set, get) => ({
  data: {},
  loading: [],
  loaded: [],
  timing: {},
  isLoading: false,
  insertData: (dataSetId, rows) => {
    set(state => {
      const currentData = state.data[dataSetId] || []
      const newData = [...currentData, ...rows].sort(
        (a, b) => b['all_sz'] - a['all_sz']
      )
      return { data: { ...state.data, [dataSetId]: newData } }
    })
  },
  loadDataSet: async dataSetId => {
    const t0 = performance.now()
    set(state => ({
      loading: [...state.loading, dataSetId],
      isLoading: true
    }))
    const data = await loadDataSet(dataSetId, get().insertData)
    const dataStore = shapeData(data, dataSetId)

    const loadTime = performance.now() - t0
    set(state => ({
      loading: state.loading.filter(v => v !== dataSetId),
      isLoading:
        state.loading.filter(v => v !== dataSetId).length > 0,
      loaded: [...state.loaded, dataSetId],
      data: { ...state.data, [dataSetId]: dataStore },
      timing: {
        ...state.timing,
        [dataSetId]: loadTime
      }
    }))
    logger.debug('loaded dataset:', dataSetId, dataStore, loadTime)
    return dataStore
  }
}))

export default useStaticData
